import axios from "axios";
import router from '../router'


const params = {
  'baseUrl': '/api/',
  'eventUrl': 'event/',
  'eventsUrl': 'events/',
  'directionsUrl': 'directions/',
  'membersUrl': 'members/',
  'customersUrl': 'customers/',
  'promoUrl': 'promocode/',
  'orderUrl': 'order/',
  'blankUrl': 'blank/',
  'availableCountsUrl': 'available-places/',
  'cart': 'cart/',
};

/**
 *
 * @param email
 * @returns {boolean}
 */

/* eslint-disable */
function checkEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

/* eslint-disable */

/* global WecanGtm */
export default {
  /*saveEventId(context, eventId) {
    return axios.get(params.baseUrl + params.eventUrl + eventId);
  },*/
  saveMembersCount(context, count) {
    axios.get(params.baseUrl + params.membersUrl + count).then(function (res) {
      context.commit('setCurrentEvent', res.data);
    });
  },
  checkCustomers: function (context) {
    let errors = 0;
    const self = this;

    for (let id in this.state.customers) {
      if (this.state.customers.hasOwnProperty(id)) {
        let customer = this.state.customers[id];

        for (let id in customer) {
          if (customer.hasOwnProperty(id)) {
            let field = customer[id];

            field.isError = false;

            for (let fieldId in this.state.currentEvent.event_customer_fields) {
              let customerField = this.state.currentEvent.event_customer_fields[fieldId];

              if (customerField.code === id && customerField.required && !field.value) {
                field.isError = true;
                field.error = '';
                errors++;
              }
            }

            if (
              field.value && (
                (id === 'phone' && !field.isValid)
                || (id === 'email' && !checkEmail(field.value))
                || (id === 'birth_date' && field.value.length < 10)
                || (id === 'passport_date' && field.value.length < 10)
                || (id === 'passport' && field.value.length < 9)
                || (id === 'passport_rf' && field.value.length < 11)
              )
            ) {
              field.isError = true;
              field.error = 'Некорректный ввод';
              errors++;
            }

            if (field.value && (id === 'birth_date') && !field.isError) {
              let dates = field.value.split('.');
              let date = new Date(dates[2], dates[1] - 1, dates[0]);
              let nowDate = new Date();

              if (date > nowDate || nowDate.getFullYear() - date.getFullYear() < 16) {
                field.isError = true;
                errors++;
                field.error = 'К сожалению мы не берем детей в путешествия, кроме детских недель';
              }

              if (date.getFullYear() < 1940) {
                field.isError = true;
                errors++;
                field.error = 'Год рождения должен быть больше 1940';
              }
            }

            if (field.value && (id === 'passport_date') && !field.isError) {
              let dates = field.value.split('.');
              let date = new Date(dates[2], dates[1] - 1, dates[0]);
              let nowDate = new Date();

              if (date < nowDate) {
                field.isError = true;
                errors++;
                field.error = 'Дата окончания паспорта не может быть раньше текущей даты';
              }
            }
          }
        }
      }

    }

    if (!errors) {
      this.dispatch('saveCustomers');

      if (self.state.customers.length < self.state.membersCount) {
        context.commit('addCustomer');
      } else {
        router.push('confirm')
      }
    }
  },
  saveCustomers() {
    let customers = JSON.stringify(this.state.customers);
    localStorage.setItem('customers', customers)
  },
  checkPromocode(context, promo) {
    axios.post(params.baseUrl + params.promoUrl, {
      promo,
      email: this.state.customers[0].email.value,
      eventId: this.state.currentEventId,
      membersCount: this.state.membersCount,
    }).then(function (res) {
      if (res.data && res.data.error) {
        console.error(res.data.error);
        return;
      }

      if (res.data) {
        context.commit('setCurrentEvent', res.data);
        context.commit('setPromo', promo);
      }
    });
  },
  saveOrder(context, order) {
    context.commit('setOrderAddressError', '');
    axios.post(params.baseUrl + params.orderUrl, order).then(function (res) {
      if (res.data) {
        if (res.data.success) {

          context.commit('setInvoice', res.data.invoice);
          context.commit('setOrder', res.data.order);
          context.commit('setCustomerId', res.data.customer_id);
          router.push({
              name: 'pay'
          })
        } else if (res.data.error && res.data.error.address) {
          context.commit('setOrderAddressError', res.data.error.address);
        }
      }
    });
  },
  saveBlank(context, blank) {
    axios.post(params.baseUrl + params.blankUrl, {
      'blank': blank,
      'customer_id': this.state.customerId
    }).then(function (res) {
      if (res.data) {
        context.commit('setEmptyBlank');
      }
    });
  },
  getAvailablePlacesCount(context) {
    return new Promise((resolve) => {
      if (!this.state.currentEvent.id) {
        context.commit('setAvailablePlacesCount', 0);
        return resolve(0);
      }

      axios.get(params.baseUrl + params.availableCountsUrl + this.state.currentEvent.id +
        '?customer_id=' + this.state.customerId)
        .then((res) => {
          if (res.data) {
            if (res.data.success && res.data.value >= 0) {
              context.commit('setAvailablePlacesCount', parseInt(res.data.value));
              return resolve(res.data.value);
            }
          }

          return resolve(0);
        });
    });
  },
  getEvents(context, slug) {
    const customerId = this.state.customerId || 0;

    axios.get(params.baseUrl + params.eventsUrl + '?customer_id=' + customerId + '&slug=' + slug)
      .then((res) => {
        if (res.data) {
          if (res.data.length) {
            context.commit('setEvents', res.data);
          }
        }
      });
  },
  getEvent(context, func) {
    if (!this.state.currentEventId || !this.state.membersCount) {
      return;
    }

    context.commit('setIsLoader', true);

    axios.get(params.baseUrl + params.eventUrl + this.state.currentEventId, {
      params: {
        membersCount: this.state.membersCount,
        promocode: this.state.promo
      }
    })
      .then((res) => {
        context.commit('setIsLoader', false);
        if (res.data.id) {
          context.commit('setCurrentEvent', res.data);
        } else {
          router.push({
            name: 'directions'
          })
        }
      });
  },
  getDirections(context) {
    axios.get(params.baseUrl + params.directionsUrl)
      .then((res) => {
        if (res.data) {
          if (res.data.length) {
            context.commit('setDirections', res.data);
          }
        }
      });
  },
}
